const processOrderStatus = ({ status }: { status: string }) => {
  const endpointParams: Record<
    'status' | 'refundStatus' | 'shippingStatus' | 'excludedRefundStatus',
    string
  > = {
    status: '',
    refundStatus: '',
    shippingStatus: '',
    excludedRefundStatus: '',
  };
  switch (status) {
    case 'ALL':
      endpointParams.status = 'CONFIRMED,COMPLETED,REJECTED';
      break;
    case 'COMPLETED':
      endpointParams.status = 'COMPLETED';
      endpointParams.shippingStatus = 'DISPATCHED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'CONFIRMED':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'NOT_SHIPPED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'DISPATCHED':
      endpointParams.status = 'CONFIRMED';
      endpointParams.shippingStatus = 'DISPATCHED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'REFUNDED':
      endpointParams.status = 'COMPLETED';
      endpointParams.refundStatus = 'REFUNDED';
      break;
    case 'REJECTED':
      endpointParams.status = 'REJECTED';
      endpointParams.shippingStatus = 'NOT_SHIPPED';
      endpointParams.excludedRefundStatus = 'REFUNDED,PARTIALLY_REFUNDED';
      break;
    default:
      endpointParams.status = status;
      break;
  }

  return endpointParams;
};

const getFormattedOrderStatus = ({ item }: { item: any }) => {
  let status = item.orderStatus;
  if (status === 'COMPLETED' && item.refundStatus === 'REFUNDED') {
    return item.refundStatus;
  }
  if (['CONFIRMED'].includes(status) && item.shippingStatus === 'DISPATCHED') {
    return 'DISPATCHED';
  }
  if (['COMPLETED', 'CONFIRMED'].includes(status)) {
    return status;
  }
  if (status === 'CANCELLED') {
    return 'CANCELLED';
  }
  if (item.refundStatus) {
    status = item.refundStatus;
  } else if (item.shippingStatus === 'DISPATCHED') {
    status = item.shippingStatus;
  }
  return status;
};

export { processOrderStatus, getFormattedOrderStatus };
